import React from 'react'
import { useLocation, Navigate } from 'react-router-dom'
import { Loader, Flex, Text } from '@aws-amplify/ui-react'
import { useAuthenticator } from './amplify'

export function RequireAuth({ children }: { children: any }) {
  const location = useLocation()
  const { authStatus } = useAuthenticator();

  // Show loading while authentication state is being determined
  if (authStatus === 'configuring') {
    return (
      <Flex direction="column" alignItems="center" padding="2rem">
        <Loader size="large" />
        <Text marginTop="1rem" fontSize={'large'}>Loading authentication...</Text>
      </Flex>
    )
  }

  // Redirect to login if not authenticated
  if (authStatus !== 'authenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children
}
